'use strict';

var React = require('react');

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n["default"] = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var _path$3;

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$3({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M4.096 11.512 9.5 17 20.412 6.57",
    stroke: "#22222D",
    strokeWidth: 1.3
  })));
};

var _path$2;

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$2({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M6.632 11.307 12 16.977l5.413-5.67M12 16.976V4.436M6.5 20h11",
    stroke: "#22222D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$1;

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

var SvgExclamationMark = function SvgExclamationMark(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.98 11.568a9.588 9.588 0 1 1 19.176 0 9.588 9.588 0 0 1-19.176 0ZM11.568.42C5.411.42.42 5.411.42 11.568s4.991 11.148 11.148 11.148 11.148-4.991 11.148-11.148S17.725.42 11.568.42ZM9.662 6.154a.715.715 0 0 1 .408-.733 3.168 3.168 0 0 1 2.67.004.725.725 0 0 1 .416.717l-.543 6.224a1.104 1.104 0 0 1-2.197.036l-.754-6.248Zm1.906 11.232c.337 0 .632-.127.885-.38.252-.252.379-.547.379-.884 0-.337-.127-.632-.38-.884a1.213 1.213 0 0 0-.884-.38c-.337 0-.632.127-.885.38-.252.252-.379.547-.379.884 0 .337.127.632.38.884.252.253.547.38.884.38Z",
    fill: "#22222D"
  })));
};

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgMinusCircle = function SvgMinusCircle(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M8 12h8M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z",
    stroke: "#22222D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

exports.SvgCheck = SvgCheck;
exports.SvgDownload = SvgDownload;
exports.SvgExclamationMark = SvgExclamationMark;
exports.SvgMinusCircle = SvgMinusCircle;
